import { useQuery } from '@tanstack/react-query';

import { getFlightCampaignDeals } from '~/services/FlightsService';

export const FLIGHT_CAMPAIGN_DEALS_QUERY_KEY = 'flightCampaignDeals';

export function useFlightCampaignDeals(id: string) {
  const {
    data = [],
    isLoading: loading,
    error,
    refetch,
  } = useQuery<Array<App.FlightDeal>, Error>({
    queryKey: [FLIGHT_CAMPAIGN_DEALS_QUERY_KEY, id],
    queryFn: async () => {
      const { result } = await getFlightCampaignDeals(id);
      return result.rows;
    },
    enabled: !!id,
  });

  return { loading, error, data, revalidate: refetch };
}
